import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, FileText, Upload, KeyRound, LogOut, ExternalLink, Users } from "lucide-react";
import { useAuth } from "./AuthContext";
import { LogoMark } from "../components/layout/Logo";
import { cx } from "../lib/format";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/articles", label: "Articles", icon: FileText },
  { to: "/admin/import", label: "CSV Import", icon: Upload },
  { to: "/admin/subscribers", label: "Subscribers", icon: Users },
  { to: "/admin/tokens", label: "API Tokens", icon: KeyRound },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="flex min-h-screen bg-ab-soft" data-testid="admin-layout">
      <aside className="hidden w-60 shrink-0 flex-col border-r border-ab-border bg-white p-5 md:flex">
        <Link to="/admin" className="flex items-center gap-2.5"><LogoMark size={28} /><span className="font-serif text-lg font-semibold">ArticleBlogs <span className="text-ab-muted">CMS</span></span></Link>
        <nav className="mt-8 flex-1 space-y-1" aria-label="Admin">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => cx("flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors", isActive ? "bg-ab-accent-soft text-ab-accent-hover" : "text-ab-text-2 hover:bg-ab-soft")} data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <n.icon size={17} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-ab-border pt-4 text-xs text-ab-muted">
          <p className="truncate font-medium text-ab-text">{user?.email}</p>
          <div className="mt-3 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-1 hover:text-ab-accent" data-testid="admin-view-site-link"><ExternalLink size={12} /> View site</Link>
            <button type="button" onClick={logout} className="flex items-center gap-1 hover:text-ab-accent" data-testid="admin-logout-button"><LogOut size={12} /> Sign out</button>
          </div>
        </div>
      </aside>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 overflow-x-auto border-b border-ab-border bg-white px-4 py-3 md:hidden">
          {NAV.map((n) => <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => cx("whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold", isActive ? "bg-ab-accent text-white" : "bg-ab-soft")}>{n.label}</NavLink>)}
          <button type="button" onClick={logout} className="ml-auto text-xs font-semibold text-ab-muted">Sign out</button>
        </div>
        <div className="p-5 sm:p-8 lg:p-10"><Outlet /></div>
      </div>
    </div>
  );
}
